export default "__VITE_ASSET__zyenw9IF__"